import React from 'react';
import PropTypes from 'prop-types';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import CTAButton from '@components/CTAButton';
import { useTranslation } from 'react-i18next';
import { Overlay, Card, IconWrapper, Body, Buttons, YesButton } from './styles';

const DeleteConfirmDialog = ({ message, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Overlay onClick={onCancel}>
      <Card onClick={(e) => e.stopPropagation()}>
        <IconWrapper>
          <DeleteForeverOutlinedIcon sx={{ fontSize: 52, color: 'error.main' }} />
        </IconWrapper>
        <Body>
          <Text size={TEXT_SIZE.T3} textColor={TEXT_COLOR.DISABLED}>
            {message}
          </Text>
        </Body>
        <Buttons>
          <YesButton primary onClick={onConfirm}>
            {t('Actions.Simple.yes')}
          </YesButton>
          <CTAButton cancel onClick={onCancel}>
            {t('Actions.Instance.cancel')}
          </CTAButton>
        </Buttons>
      </Card>
    </Overlay>
  );
};

DeleteConfirmDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeleteConfirmDialog;
